import Button from "gamfi/components/button";
import BannerStyleWrapper from "gamfi/sections/Banner/v2/Banner.style";
import { exploded } from "utils/time";

import rocketThumb from "assets/tokens/icon-energy.png";
// import rocketThumb from "gamfi/assets/images/homeV2/rocket-front-color.png";
import rocketParticle from "gamfi/assets/images/homeV2/rocketStar.svg";
import { useHandleNavigate } from "utils/hooks";
import { Col, Row } from "react-flexbox-grid";

import enIcon from "assets/languages/en.png";
import esIcon from "assets/languages/es.png";
import deIcon from "assets/languages/de.png";

const MainBanner = () => {
  const navigate = useHandleNavigate();
  const particles = [rocketParticle, rocketParticle, rocketParticle, rocketParticle, rocketParticle];
  return (
    <>
      <BannerStyleWrapper>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="gamfi_v2_hero_left">
                <h2>
                  Metaverse Energy Web <span>3.0</span> Ecosystem
                </h2>
                <p>The next generation gaming ecosystem for IGOs and NFT market</p>
                <div className="banner-btns">
                  <Button href="/projects-classic-1" md onClick={navigate(`/history`)}>
                    View History
                  </Button>
                  {exploded() ? (
                    <Button href={`#`} md onClick={navigate(``)} variant="outline">
                      Buy Tokens
                    </Button>
                  ) : (
                    <Button href={`#`} md onClick={navigate(`/airdrop`)} variant="outline">
                      Airdrop
                    </Button>
                  )}
                </div>

                <div className="buy_token">
                  <h6>SELECT LANGUAGE</h6>
                  <Row>
                    <Col xs={10} sm={9} md={7}>
                      <Row>
                        <Col xs>
                          <a href="#">
                            <img src={enIcon} alt="en logo" className="img-fluid" />
                          </a>
                        </Col>
                        <Col xs>
                          <a href="#">
                            <img src={esIcon} alt="es logo" className="img-fluid" />
                          </a>
                        </Col>
                        <Col xs>
                          <a href="#">
                            <img src={deIcon} alt="de logo" className="img-fluid" />
                          </a>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="gamfi_v2_hero_right">
                <div className="gamfi_v2_hero_thumb">
                  <span className="rocket_thumb">
                    <img src={rocketThumb} alt="Rocket thumb" />
                  </span>

                  {particles?.map((particle, i) => (
                    <span key={i} className={`rocket_particle particle_${i + 1}`}>
                      <img src={particle} alt="rocket particle" />
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </BannerStyleWrapper>
    </>
  );
};

export default MainBanner;
